<template lang="pug">
.v-mob-menu.mob-menu(v-if="data")
	button.btn.btn--magenta.btn--sm.mob-menu__open-btn(type="button" @click="open = true")
		v-svg-icon.btn__icon(icon="burger")
		| {{data.title}}
	teleport(to="body")
		transition(name="mob-menu")
			.mob-menu__panel(v-if="open")
				.mob-menu__panel-header
					component.mob-menu__logo(v-if="data.logo" :is="data.logo.link ? 'a' : 'div'" :href="data.logo.link")
						img.mob-menu__logo-icon(:src="data.logo.src" :alt="data.logo.alt")
					component(is="button" type="button" :class="['locale__button','top-link__item-btn',  'active']" @click="openModal = true")
						span(class="top-link__item-text") {{selectLocaleValue}}
						v-svg-icon(icon="select-arrow" class="top-link__item-icon")
						//teleport(to="body")
					v-modal.locale-modal(v-if="openModal" @close="() => this.openModal = null")
						v-navigation-links.locale-modal__items(:items="[{text: 'Ru',link: '#'},{text: 'En',link: '#'}]" :without-icon="true" :is-selected="true" @model-value="(e) => selectLocaleValue = e.text")
					v-panel.mob-menu__remotes(v-if="data.remotes" :close-text="data.closeText")
						template(#btn)
							button.btn.btn--stroke.btn--sm( type="button")
								| {{data.remotes.title}}
								v-svg-icon.btn__arrow(icon="select-arrow")
						template(#content)
							.mob-menu__remotes-buttons(v-if="data.remotes.items")
								a.mob-menu__remotes-button.btn.btn--gray(v-for="item in data.remotes.items" :href="item.link") {{item.text}}
					button.mob-menu__close-btn.btn.btn--magenta.btn--sm(type="button" @click="open = false")
						v-svg-icon.mob-menu__close-btn-icon(icon="cross-sm")
				.mob-menu__panel-body(ref="body")
					.mob-menu__tabs.tags(v-if="data.tabs")
						.tags__items(ref="tabs")
							a.mob-menu__tab.tags__item(v-for="tab in data.tabs" :href="tab.link" :class="tab.active ? 'active' : ''") {{tab.text}}
					.mob-menu__acc(v-if="data.items")
						.mob-menu__acc-item.mob-menu__acc-item--other(v-for="(item, i) in data.other" :class="{'open': item.open}")
							.mob-menu__acc-item-head(@click="data.other[i].open = !data.other[i].open")
								span.mob-menu__acc-item-title {{item.text}}
								v-svg-icon.mob-menu__acc-item-icon(v-if="item.icon" :icon="item.icon")
								v-svg-icon.mob-menu__acc-item-arrow(icon="dropdown-small")
							v-collapse(:open="item.open")
								.mob-menu__acc-item-body
									v-navigation-links(v-if="item.items" :items="item.items")
									.mob-menu__item-aside(v-if="item.aside")
										.mob-menu__item-aside-tilte(v-if="item.aside.title") {{item.aside.title}}
										.mob-menu__item-aside-links(v-if="item.aside.links")
											a.mob-menu__item-aside-link(v-for="linkItem in item.aside.links" :href="linkItem.link") {{linkItem.text}}
						.mob-menu__acc-item(v-for="(item, i) in data.items" :class="{'open': item.open}")
							.mob-menu__acc-item-head(@click="data.items[i].open = !data.items[i].open")
								component.mob-menu__acc-item-title(:is="item.link ? 'a' : 'span'" :href="item.link") {{item.text}}
								v-svg-icon.mob-menu__acc-item-arrow(v-if="item.items" icon="dropdown-small")
							v-collapse(v-if="item.items" :open="item.open")
								.mob-menu__acc-item-body
									.mob-menu__acc-group(v-for="group in item.items")
										component.mob-menu__acc-group-title(v-if="group.title" :is="group.title.link ? 'a' : 'div'" :href="group.title.link ? group.title.link : ''") {{group.title.text}}
										v-navigation-links(v-if="group.links" :items="group.links")
									.mob-menu__item-aside(v-if="item.aside")
										.mob-menu__item-aside-tilte(v-if="item.aside.title") {{item.aside.title}}
										.mob-menu__item-aside-links(v-if="item.aside.links")
											a.mob-menu__item-aside-link(v-for="linkItem in item.aside.links" :href="linkItem.link") {{linkItem.text}}
					.mob-menu__buttons
						a.mob-menu__button.btn.btn--gray(v-if="data.atms" :href="data.atms.link")
							v-svg-icon.btn__icon(:icon="data.atms.icon")
							| {{data.atms.text}}
						v-panel.mob-menu__button(v-if="data.contacts" :close-text="data.closeText")
							template(#btn)
								button.btn.btn--gray.mob-menu__button(type="button")
									v-svg-icon.btn__icon(:icon="data.contacts.icon")
									| {{data.contacts.text}}
							template(#content)
								v-contacts
						button.mob-menu__button.btn.btn--gray(v-if="data.search" type="button" @click="handlerOpenSearch")
							v-svg-icon.btn__icon(:icon="data.search.icon")
							| {{data.search.text}}

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import scrollLock from 'scroll-lock';
import {nextTick} from "vue";
import controller from "../scripts/controller/controller";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			open: false,
			active: null,
			openModal: null,
			selectLocaleValue: 'Ru',
		}
	},

	watch: {
		async open(state) {
			if (state) {
				await nextTick();
				scrollLock.disablePageScroll([this.$refs.body, this.$refs.tabs]);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.body);
				}, 300);
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;

			if(data.items) {
				this.active = data.items[0];
			}
		},

		handlerOpenSearch() {
			controller.events.emit('openSearch');
		}
	}
}

</script>